import axiosConfig from '@/sso/axios-config'
import { filterParameters } from '@/util/common'

export async function exportData(path, condition) {
  const copy = filterParameters(condition)

  const data = {
    condition: copy,
  }

  return await axiosConfig.service({
    url: path,
    method: 'post',
    data: data,
  })
}

export async function list(exportType) {
  const data = {
    exportTypeCode: exportType,
  }
  return await axiosConfig.service({
    url: '/export/list',
    method: 'post',
    data: data,
  })
}
